<template lang="pug">
  .numberCircle {{ text }}
</template>

<script>

export default {
  name: 'NumberCircle',
  props: {
    text: {
      default: 'Sample Title',
      type: String
    }
  }
}
</script>

<style lang="scss" scoped>
.numberCircle {
  margin-right: 15px;
  height: 36px;
  color: #A34936;
  font-size: 1.7rem;
  width: 2rem;
  text-align: center;
  border: 2px solid #A34936;
  padding: 1rem;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
}
</style>
